import { Bookmark, BookmarkBorder } from "@mui/icons-material";
import { ListingTopSectionAction } from "./ListingTopSectionAction";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { useSavedListing } from "../../../../hooks/trainingPlan/useSavedListing";
import {
  SaveListingOptions,
  updateSaveListingWishlist,
} from "../../../../api/listings";
import useUser from "../../../../hooks/user/useUser";
import { setIsSavedListing } from "../../../../redux/pages/trainingPlanSlice";

export const ListingSaveWishlist = () => {
  const userRedux = useSelector((state: RootState) => state.user.value);
  const { user } = useUser();
  const isSaved = useSelector(
    (state: RootState) => state.trainingPlan.isSavedListing,
  );
  const listingRedux = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );
  const dispatch = useDispatch();

  const saveAction = () => {
    dispatch(setIsSavedListing(true));
    updateSaveListingWishlist(
      listingRedux.id,
      SaveListingOptions.PUT,
      user.token,
    ).catch((error) => console.error(error));
  };

  const unsaveAction = () => {
    dispatch(setIsSavedListing(false));
    updateSaveListingWishlist(
      listingRedux.id,
      SaveListingOptions.DELETE,
      user.token,
    ).catch((error) => console.error(error));
  };

  useSavedListing();

  if (isSaved !== undefined && isSaved === true) {
    return (
      <ListingTopSectionAction
        onClick={unsaveAction}
        startIcon={<Bookmark />}
        disabled={!userRedux.loggedUser}
      >
        Saved
      </ListingTopSectionAction>
    );
  }

  return (
    <ListingTopSectionAction
      onClick={saveAction}
      startIcon={<BookmarkBorder />}
      disabled={!userRedux.loggedUser}
    >
      Save
    </ListingTopSectionAction>
  );
};
